import React from 'react';
import TopNavbar from './components/Navbar';
import { Routes, Route} from 'react-router-dom';
import AuthOutlet from '@auth-kit/react-router/AuthOutlet'

import './App.css';
import Home from './pages/Home';
import Task from './pages/Task';
import EditTask from './pages/editTask';
import NewTask from './pages/newTask';
import ExportTasks from './components/exportTasks';
import Customers from './pages/Customers';
import Customer from './pages/Customer';
import NewCustomer from './pages/newCustomer';
import EditCustomer from './pages/editCustomer';
import ExportCustomers from './components/exportCustomers';
import Employees from './pages/Employees';
import Employee from './pages/Employee';
import NewEmployee from './pages/newEmployee';
import EditEmployee from './pages/editEmployee';
import ExportEmployees from './components/exportEmployees';
import NoPage from './pages/NoPage';
import Export from './pages/export';
import { DEV_MODE } from './Constants';
import Partners from "./pages/Partners";
import NewPartner from "./pages/newPartner";
import logo from "./imgs/logo.png";
import OfficeEmployees from "./pages/OfficeEmployees";
import NewOfficeEmployee from "./pages/newOfficeEmployee";
import Invoices from "./pages/Invoices";
import EditCustomerInvoice from "./pages/editCustomerInvoice";
import Users from "./pages/Users";
import NewUser from "./pages/newUser";
import EditUser from "./pages/editUser";
import Login from "./pages/Login";
import EditPassword from "./pages/editPassword";


// disable debug comments
if (!DEV_MODE) {
	console.log = () => {};
	console.error = () => {}
	console.debug = () => {}
}

function App() {
	return (
		<>
			<div className="logo-container" style={{height: "70px"}}>
				<img className="logo" src={logo} alt=""></img>
			</div>

			<Routes>
				<Route element={<AuthOutlet fallbackPath='/login' />}>
					<Route path='/' element={<Home/>}/>
					<Route path="/task/:id" element={<Task/>}/>
					<Route path="/edit-task/:id" element={<EditTask/>}/>
					<Route path="/new-task" element={<NewTask/>}/>
					<Route path="/export-tasks" element={<ExportTasks/>}/>
					<Route path="/employees" element={<Employees/>}/>
					<Route path="/employee/:id" element={<Employee/>}/>
					<Route path="/edit-employee/:id" element={<EditEmployee/>}/>
					<Route path="/new-employee" element={<NewEmployee/>}/>
					<Route path="/export-employees" element={<ExportEmployees/>}/>
					<Route path="/customers" element={<Customers/>}/>
					<Route path="/new-customer" element={<NewCustomer/>}/>
					<Route path="/customer/:id" element={<Customer/>}/>
					<Route path="/edit-customer/:id" element={<EditCustomer/>} />
					<Route path="/export-customers" element={<ExportCustomers/>} />
					<Route path="/export" element={<Export/>} />
					<Route path="/partners" element={<Partners/>} />
					<Route path="/new-partner" element={<NewPartner/>} />
					<Route path="/office-employees" element={<OfficeEmployees/>} />
					<Route path="/new-office-employee" element={<NewOfficeEmployee/>} />
					<Route path="/invoices" element={<Invoices/>} />
					<Route path="/edit-customer-invoice/:id" element={<EditCustomerInvoice/>} />
					<Route path="/users" element={<Users/>} />
					<Route path="/new-user" element={<NewUser/>} />
					<Route path="/edit-user/:id" element={<EditUser/>} />
					<Route path="/edit-password/:id" element={<EditPassword/>} />
					<Route path="/no-page" element={<NoPage/>} />
				</Route>
				<Route path="/login" element={<Login/>} />
				<Route path="*" element={<NoPage/>} />
			</Routes>
		</>
	);
}

export default App;
